import { ConsiderationType } from '../../../types';

export const CONSIDERATION_ROWS = [
  {
    key: ConsiderationType.UnitsRealised,
    label: 'Units realised',
    group: '1',
  },
  {
    key: ConsiderationType.ReceivedConsiderationTotal,
    label: 'Received consideration',
    group: '1',
  },
  {
    key: ConsiderationType.ReceivedConsiderationPerUnit,
    label: 'Received consideration per unit',
    group: '1',
  },
  {
    key: ConsiderationType.EscrowConsiderationTotal,
    label: 'Escrow consideration',
    group: '1',
  },
  {
    key: ConsiderationType.EscrowConsiderationPerUnit,
    label: 'Escrow consideration per unit',
    group: '1',
  },
  {
    key: ConsiderationType.EarnoutConsiderationTotal,
    label: 'Earnout consideration',
    group: '1',
  },
  {
    key: ConsiderationType.EarnoutConsiderationPerUnit,
    label: 'Earnout consideration per unit',
    group: '1',
  },
  {
    key: ConsiderationType.WithholdingTaxPayable,
    label: 'Withholding tax',
    group: '1',
  },
];
